module.exports = __webpack_public_path__ + "img/innovation_districts.52395ac9.png";